<template>
  <svg
    id="sooniaSpinner"
    data-name="sooniaSpinner"
    viewBox="0 0 799.35 538.74"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="soonia">
      <path
        class="cls-1 svg-elem-1"
        d="M214.94,735.12a40,40,0,0,1,10.7,13.62A42.13,42.13,0,0,1,229.79,766v.93a39.92,39.92,0,0,1-3.48,16.56A43.15,43.15,0,0,1,216.88,797a44.77,44.77,0,0,1-31.1,12.42,76.32,76.32,0,0,1-21.41-3,81,81,0,0,1-19.13-8.34,9.39,9.39,0,0,1-3.47-3.5,11.1,11.1,0,0,1-1.41-4.51,10.39,10.39,0,0,1,.67-4.63,11.77,11.77,0,0,1,2.74-4.15,10.58,10.58,0,0,1,6.56-3.08,12,12,0,0,1,7.36,1.61,52.84,52.84,0,0,0,13.3,5.75,54.42,54.42,0,0,0,14.79,2,21.41,21.41,0,0,0,10.16-2.47,22,22,0,0,0,7.69-6.6,20.43,20.43,0,0,0,3.75-9.33,20.65,20.65,0,0,0-1.54-10.8,19.15,19.15,0,0,0-8.23-9.14A25.87,25.87,0,0,0,185.24,746a42.85,42.85,0,0,1-15.45-3.08,46.47,46.47,0,0,1-13-7.91,40.1,40.1,0,0,1-10.7-13.6,43.13,43.13,0,0,1-4.28-17.21v-1.08a39.87,39.87,0,0,1,3.47-16.54,44.17,44.17,0,0,1,40.54-26.06,78.22,78.22,0,0,1,21.67,3,74.83,74.83,0,0,1,19.26,8.62,9.78,9.78,0,0,1,3.34,3.43,10.57,10.57,0,0,1,1.41,4.44,11.53,11.53,0,0,1-.6,4.7,9.82,9.82,0,0,1-2.68,4.07,10,10,0,0,1-6.62,3.15,13.06,13.06,0,0,1-7.43-1.54,52.1,52.1,0,0,0-13.3-6,54,54,0,0,0-15.05-2.08A21.79,21.79,0,0,0,168,691.42a21,21,0,0,0-2.14,20.4,19.59,19.59,0,0,0,8.22,9.12,24.19,24.19,0,0,0,12.38,3.22,42.83,42.83,0,0,1,15.44,3.08A46.34,46.34,0,0,1,214.94,735.12Z"
        transform="translate(-140.33 -270.63)"
      ></path>
      <path
        class="cls-1 svg-elem-2"
        d="M324.76,809.37a72.7,72.7,0,0,1-29-5.82A74.22,74.22,0,0,1,256.2,764a75,75,0,0,1,0-57.92,74.19,74.19,0,0,1,39.6-39.6,75.08,75.08,0,0,1,57.92,0A74.22,74.22,0,0,1,393.31,706a75,75,0,0,1,0,57.92,74.24,74.24,0,0,1-39.59,39.59A72.74,72.74,0,0,1,324.76,809.37Zm0-126.54a50.49,50.49,0,0,0-20.27,4.08,52.37,52.37,0,0,0-27.69,27.76,52.69,52.69,0,0,0,0,40.66,52.37,52.37,0,0,0,27.69,27.76,52.54,52.54,0,0,0,40.6,0,52.18,52.18,0,0,0,27.76-27.76,52.69,52.69,0,0,0,0-40.66,52.18,52.18,0,0,0-27.76-27.76A51,51,0,0,0,324.76,682.83Z"
        transform="translate(-140.33 -270.63)"
      ></path>
      <path
        class="cls-1 svg-elem-3"
        d="M492.77,809.37a72.7,72.7,0,0,1-29-5.82A74.22,74.22,0,0,1,424.21,764a75,75,0,0,1,0-57.92,74.19,74.19,0,0,1,39.6-39.6,75.06,75.06,0,0,1,57.91,0,74.19,74.19,0,0,1,39.6,39.6,75,75,0,0,1,0,57.92,74.22,74.22,0,0,1-39.6,39.59A72.69,72.69,0,0,1,492.77,809.37Zm0-126.54a50.49,50.49,0,0,0-20.27,4.08,52.37,52.37,0,0,0-27.69,27.76,52.69,52.69,0,0,0,0,40.66,52.37,52.37,0,0,0,27.69,27.76,52.54,52.54,0,0,0,40.6,0,52.21,52.21,0,0,0,27.75-27.76,52.69,52.69,0,0,0,0-40.66,52.21,52.21,0,0,0-27.75-27.76A51,51,0,0,0,492.77,682.83Z"
        transform="translate(-140.33 -270.63)"
      ></path>
      <path
        class="cls-1 svg-elem-4"
        d="M651.61,660.89a59.64,59.64,0,0,1,23,5,60,60,0,0,1,31.4,31.7,58.07,58.07,0,0,1,4.61,23.08v74.37a10.6,10.6,0,0,1-3.19,7.76,10.86,10.86,0,0,1-15.42,0,10.6,10.6,0,0,1-3.19-7.76V720.69a38.39,38.39,0,0,0-3-14.85,39.72,39.72,0,0,0-8-12.38,38.74,38.74,0,0,0-12-8.42,34.91,34.91,0,0,0-14.67-3.15A37.71,37.71,0,0,0,636.07,685,39.29,39.29,0,0,0,615.3,705.7a37.11,37.11,0,0,0-3.08,15v74.37a10.6,10.6,0,0,1-3.19,7.76,10.86,10.86,0,0,1-15.42,0,10.6,10.6,0,0,1-3.19-7.76V674.8a10.58,10.58,0,0,1,3.19-7.75,10.86,10.86,0,0,1,15.42,0,10.58,10.58,0,0,1,3.19,7.75l.11,8.16a64.2,64.2,0,0,1,7.28-9.76,37.36,37.36,0,0,1,8.42-6.89,36,36,0,0,1,10.35-4.08A58.78,58.78,0,0,1,651.61,660.89Z"
        transform="translate(-140.33 -270.63)"
      ></path>
      <path
        class="cls-1 svg-elem-5"
        d="M755.75,646.58a14.56,14.56,0,0,1-5.56-1.07,13,13,0,0,1-4.47-3,15.14,15.14,0,0,1-3-4.48,12.92,12.92,0,0,1-1.14-5.35,13.29,13.29,0,0,1,4.08-10,14,14,0,0,1,10.1-3.94,13.34,13.34,0,0,1,9.83,3.94A14.36,14.36,0,0,1,768.45,638a14.39,14.39,0,0,1-2.94,4.48,13.37,13.37,0,0,1-4.35,3A13.53,13.53,0,0,1,755.75,646.58ZM755.61,806a11,11,0,0,1-11-11V674a11,11,0,0,1,22.08,0V795.06a10.55,10.55,0,0,1-3.22,7.76A10.71,10.71,0,0,1,755.61,806Z"
        transform="translate(-140.33 -270.63)"
      ></path>
      <path
        class="cls-1 svg-elem-6"
        d="M939.67,795.06a11,11,0,0,1-11,11,10.41,10.41,0,0,1-7.62-3.21,10.58,10.58,0,0,1-3.21-7.76V780.48a43.11,43.11,0,0,1-17,18.12,59.07,59.07,0,0,1-14.52,6,71.68,71.68,0,0,1-18.86,2.27,69.78,69.78,0,0,1-28-5.69,72.11,72.11,0,0,1-22.94-15.51,73.78,73.78,0,0,1-15.45-23,72,72,0,0,1,0-56.11,73.93,73.93,0,0,1,15.45-22.94,72.14,72.14,0,0,1,22.94-15.52,70,70,0,0,1,28-5.69,61.77,61.77,0,0,1,19.06,2.75,63.26,63.26,0,0,1,14.85,6.82,46.74,46.74,0,0,1,10.5,9,40,40,0,0,1,6,9V674.8a10.36,10.36,0,0,1,3.21-7.69A10.54,10.54,0,0,1,928.7,664a10.69,10.69,0,0,1,7.76,3.14,10.36,10.36,0,0,1,3.21,7.69Zm-72.23-10a49,49,0,0,0,19.6-3.95,51.52,51.52,0,0,0,16.05-10.79,50.29,50.29,0,0,0,10.83-16,50.73,50.73,0,0,0,0-39.25A50.86,50.86,0,0,0,887,688.12a50.6,50.6,0,0,0-39.2,0,50.2,50.2,0,0,0-16,10.85A51.67,51.67,0,0,0,821.09,715a50.85,50.85,0,0,0,0,39.25,50.47,50.47,0,0,0,26.75,26.79A49.07,49.07,0,0,0,867.44,785Z"
        transform="translate(-140.33 -270.63)"
      ></path>
      <path
        class="cls-2 svg-elem-7"
        d="M649.28,432.3,544.67,369.74l104.61-62.21c6.56-3.94,9.89-9.92,9.89-17.77a17.81,17.81,0,0,0-6-13.8A20.57,20.57,0,0,0,639,270.63a25.78,25.78,0,0,0-10.07,2.3l-.12.06L496.91,352.32l-.12.08c-7,4.9-10.48,10.85-10.48,17.69,0,7.6,3.55,13.7,10.57,18.11l131.74,78.9a18.23,18.23,0,0,0,10,2.81,20.67,20.67,0,0,0,14.19-5.69,18.84,18.84,0,0,0,6.36-14.51C659.17,442.36,655.86,436.51,649.28,432.3Z"
        transform="translate(-140.33 -270.63)"
      ></path>
      <path
        class="cls-2 svg-elem-8"
        d="M583.21,462.8,451.34,383.46l-.25-.13a25.69,25.69,0,0,0-10-2.3h0a20.54,20.54,0,0,0-14.18,5.33,17.82,17.82,0,0,0-6,13.8c0,7.85,3.33,13.83,9.9,17.78l104.6,62.2L430.67,542.73c-6.53,4.18-9.84,10-9.84,17.38a18.81,18.81,0,0,0,6.36,14.51,20.65,20.65,0,0,0,14.19,5.69,18.19,18.19,0,0,0,9.95-2.78L583.12,498.6c7-4.41,10.57-10.51,10.57-18.11C593.69,473.65,590.16,467.7,583.21,462.8Z"
        transform="translate(-140.33 -270.63)"
      ></path>
    </g>
  </svg>
</template>

<style scoped>
.cls-1 {
  fill: #1d1d1b;
}

.cls-2 {
  fill: #009bae;
}

/***************************************************
 * Generated by SVG Artista on 9/15/2022, 8:51:38 PM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/

@-webkit-keyframes animate-svg-fill-1 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

@keyframes animate-svg-fill-1 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

.svg-elem-1 {
  -webkit-animation: animate-svg-fill-1 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.8s both;
  animation: animate-svg-fill-1 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.8s both;
}

@-webkit-keyframes animate-svg-fill-2 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

@keyframes animate-svg-fill-2 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

.svg-elem-2 {
  -webkit-animation: animate-svg-fill-2 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.9s both;
  animation: animate-svg-fill-2 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.9s both;
}

@-webkit-keyframes animate-svg-fill-3 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

@keyframes animate-svg-fill-3 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

.svg-elem-3 {
  -webkit-animation: animate-svg-fill-3 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1s both;
  animation: animate-svg-fill-3 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1s both;
}

@-webkit-keyframes animate-svg-fill-4 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

@keyframes animate-svg-fill-4 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

.svg-elem-4 {
  -webkit-animation: animate-svg-fill-4 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.1s both;
  animation: animate-svg-fill-4 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.1s both;
}

@-webkit-keyframes animate-svg-fill-5 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

@keyframes animate-svg-fill-5 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

.svg-elem-5 {
  -webkit-animation: animate-svg-fill-5 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.2000000000000002s
    both;
  animation: animate-svg-fill-5 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.2000000000000002s both;
}

@-webkit-keyframes animate-svg-fill-6 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

@keyframes animate-svg-fill-6 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(29, 29, 27);
  }
}

.svg-elem-6 {
  -webkit-animation: animate-svg-fill-6 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.3s both;
  animation: animate-svg-fill-6 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.3s both;
}

@-webkit-keyframes animate-svg-fill-7 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 155, 174);
  }
}

@keyframes animate-svg-fill-7 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 155, 174);
  }
}

.svg-elem-7 {
  -webkit-animation: animate-svg-fill-7 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.4000000000000001s
    both;
  animation: animate-svg-fill-7 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.4000000000000001s both;
}

@-webkit-keyframes animate-svg-fill-8 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 155, 174);
  }
}

@keyframes animate-svg-fill-8 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 155, 174);
  }
}

.svg-elem-8 {
  -webkit-animation: animate-svg-fill-8 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.5s both;
  animation: animate-svg-fill-8 1s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.5s both;
}
</style>
